import { TableTask, Task } from '@qtek/shared/models';

export type TaskRow = Task | TableTask;
export type TasksByMysid = Record<string, TaskRow[]>;
export interface TaskQueryParams {
  statusType?: string;
  assignedByMe?: boolean;
  ownerType?: string;
  includeAssigned?: boolean;
  [key: string]: unknown;
}

const replaceTask = (tasks: TaskRow[], task: TaskRow) =>
  tasks.map(t => (t._id === task._id ? task : t));

const removeTask = (tasks: TaskRow[], id: string) =>
  tasks.filter(t => t._id !== id);

const isOutstandingList = (prms: TaskQueryParams | undefined) =>
  prms?.ownerType === 'PERSON' && prms?.includeAssigned === true;

export function applyInsTask(
  allTasks: TasksByMysid,
  queryParams: Record<string, TaskQueryParams>,
  task: TaskRow,
  mysid: string
): TasksByMysid {
  const prms = queryParams[mysid];
  const existing = allTasks[mysid] ?? [];
  const known = existing.some(t => t._id === task._id);
  const authorId = task.taskParams?.authorId?.[0];

  if (prms?.assignedByMe === true) {
    if (authorId && task.user === authorId) return allTasks;
    if (known) return { ...allTasks, [mysid]: replaceTask(existing, task) };
  }

  if (isOutstandingList(prms)) {
    if (authorId && task.user !== authorId) return allTasks;
    if (known) return { ...allTasks, [mysid]: replaceTask(existing, task) };
  }

  return { ...allTasks, [mysid]: [task, ...existing] };
}

// Updates reach every active list, not only the channel that received them.
export function applyUpdTask(
  allTasks: TasksByMysid,
  queryParams: Record<string, TaskQueryParams>,
  task: TaskRow
): TasksByMysid {
  const next = { ...allTasks };

  for (const mysid of Object.keys(queryParams)) {
    const prms = queryParams[mysid];
    const existing = allTasks[mysid] ?? [];

    if (prms?.statusType && task.statusType !== prms.statusType) {
      next[mysid] = removeTask(existing, task._id);
      continue;
    }

    const current = existing.find(t => t._id === task._id);
    if (!current) {
      next[mysid] = existing;
      continue;
    }

    if (prms?.assignedByMe === true) {
      const authorId = task.taskParams?.authorId?.[0];
      next[mysid] =
        authorId && task.user === authorId
          ? removeTask(existing, task._id)
          : replaceTask(existing, task);
    } else if (isOutstandingList(prms)) {
      next[mysid] =
        current.user !== task.user
          ? removeTask(existing, task._id)
          : replaceTask(existing, task);
    } else {
      next[mysid] = replaceTask(existing, task);
    }
  }

  return next;
}

export function removeTaskFromList(
  allTasks: TasksByMysid,
  mysid: string,
  id: string
): TasksByMysid {
  return { ...allTasks, [mysid]: removeTask(allTasks[mysid] ?? [], id) };
}
